module.exports = __webpack_public_path__ + "book.png?0d5d66b6c55d5e6afafb60cfdcaeac31";


//////////////////
// WEBPACK FOOTER
// ./static/images/book.png
// module id = 13
// module chunks = 0 1